import axios from 'axios'

import store from '@/store'

export default {
  getHomeSettings () {
    return axios.get(`${process.env.VUE_APP_API_SETTINGS_URI}/home/`, {
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => response.data)
  },
  getCoreSettings () {
    return axios.get(`${process.env.VUE_APP_API_SETTINGS_URI}/core/`, {
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => response.data)
  },
  getDashSettings () {
    return axios.get(`${process.env.VUE_APP_API_SETTINGS_URI}/dashboard/`, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },
  /**
   * Llama al endpoint que retorna la lista de items del menu principal
   */
  getMainMenuSettings () {
    return axios.get(`${process.env.VUE_APP_API_SETTINGS_URI}/mainmenu/`, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => response.data)
  },

  /**
   * Llama al endpoint que retorna la lista de items del Vue Router
   */
  getRoutesConfigs () {
    return axios.get(`${process.env.VUE_APP_API_SETTINGS_URI}/routesconfig/`, {
      // De momento no puede estar autenticado el endpoint que retorna las rutas
      // headers: {
      //   Authorization: `Bearer ${store.state.session.accessToken}`
      // }
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => response.data)
  },
  /**
   * Obtiene desde la API las opciones asociadas con el listado
   * @param {*} uri para completar el endpoint a llamar
   */
  getListSettings (endpointUri) {
    return axios.get(`${process.env.VUE_APP_API_SETTINGS_URI}/${endpointUri}`, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => response.data)
  },
  /**
   * Obtiene desde la API las opciones asociadas con agregar o editar
   * @param {*} uri para completar el endpoint a llamar
   */
  geAddOrEditSettings (endpointUri) {
    return axios.get(`${process.env.VUE_APP_API_SETTINGS_URI}/${endpointUri}`, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      },
      cancelToken: store.state.session.cancelTokenSource.token
    })
      .then(response => response.data)
      .catch(error => error)
  }
}
